import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useBlog } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { useI18n, getLocale } from "@/lib/i18n";
import { IMG } from "@/lib/content";
import { SplitText } from "@/components/fx/Motion";

const FALLBACK = [IMG.bellecare, IMG.primus, IMG.hero];
export const fmtDate = (d) => {
  try { return new Date(d).toLocaleDateString(getLocale(), { day: "numeric", month: "long", year: "numeric" }); }
  catch { return new Date(d).toLocaleDateString("en-GB"); }
};

export default function Blog() {
  const { t } = useI18n();
  const { data = [], isLoading } = useBlog();
  useSeo(t("blog_title"));
  return (
    <div data-testid="blog-page" className="max-w-7xl mx-auto px-5 lg:px-10 py-14 lg:py-20">
      <p className="eyebrow mb-4">{t("blog_eyebrow")}</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl mb-14"><SplitText text={t("blog_title")} /></h1>
      {isLoading && <div className="h-64 bg-white/5 animate-pulse" />}
      <div className="grid md:grid-cols-3 gap-10">
        {data.map((a, i) => (
          <motion.div key={a.handle} initial={{ opacity: 0, y: 60 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.9, delay: i * 0.12 }}>
            <Link to={`/blog/${a.handle}`} data-testid={`blog-card-${a.handle}`} className="group block">
              <div className="aspect-[4/3] overflow-hidden bg-white">
                <img src={a.image || FALLBACK[i % 3]} alt={a.title} className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-110" />
              </div>
              <p className="text-[11px] uppercase tracking-[0.2em] text-white/40 mt-5">{fmtDate(a.published_at)}</p>
              <h2 className="font-display text-xl lg:text-2xl mt-2 group-hover:text-gold transition-colors">{a.title}</h2>
              <p className="text-sm text-white/55 mt-3 line-clamp-3">{a.excerpt}</p>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
